import { Icon } from '../../../../imagesAndIcons/Icon';
export var ICON_DEFAULTS = {
  stroke: Icon.Stroke.Dark,
  size: Icon.Size.Sm
};